var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdc-icon mdc-icon--material",class:{'material-icons':!!_vm.icon, 'material-icons-outlined':_vm.outlined}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.icon))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }